<homey-lotteries-dialog-content
  singleDescription="We will immediately submit applications for the following lotteries, and will keep auto-applying to new lotteries that match your preferences."
  multipleDescription="We will immediately submit applications for the following lotteries, and will keep auto-applying to new lotteries that match your preferences."
  singleTitle="Auto-applying to this lottery"
  multipleTitle="Auto-applying to these lotteries"
  [closeButton]="closeButton()"
  [notification]="data()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-open-lottery-list-item [noNegativeMargin]="true" [openInPopup]="true" [lottery]="lottery"></homey-open-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
